export default __webpack_public_path__ + "static/media/Edit.3a0d82b2.png";